<template lang="pug">
    select.form-control(v-bind:value="value")
        option(v-for="option in options", :value="option.value") {{ option.html }}
</template>

<script>
    import Vue from 'vue';

    import $ from '@rover/globals/jquery';

    export default {
        props: {
            options: {
                type: Array,
                required: true,
            },
            value: {
                type: String,
                required: false,
            },
            showSearch: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        mounted() {
            const select2Options = {
                escapeMarkup: m => m,
            };
            if (!this.showSearch) {
                select2Options.minimumResultsForSearch = Infinity;
            }

            const $el = $(this.$el);
            $el
                .select2(select2Options)
                .on('change', (e) => {
                    this.$emit('input', $(e.target).val());
                    $el.parent().find('.select2-selection__rendered').removeAttr('title');
                });
            $el.parent().find('.select2-selection__rendered').removeAttr('title');
        },
        watch: {
            value(v) {
                $(this.$el).val(v).trigger('change');
            },
        },
        destroyed() {
            $(this.$el).off().select2('destroy');
        },
    };
</script>



// WEBPACK FOOTER //
// HtmlCapableSelectBox.vue?3c69ec37